import SignRoutes from "./SignRoutes"
import OtherRoutes from "./OtherRoutes"
import { useAuth } from "../hooks/useAuth"
import { CoreProvider } from "../contexts/coreContext"
import { mustChangePassword } from "../utils/mustChangePassword"

export default function AppRoutes(): JSX.Element {
	const { signed, user } = useAuth()

	return signed && !mustChangePassword(user)
			? <CoreProvider>
					<OtherRoutes />
				</CoreProvider>
			: <SignRoutes/>
}